const NawyDomainLogo = () => {
  return (
    <>
      <svg
        width="115"
        height="28"
        viewBox="0 0 115 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_15932_142896"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="28"
        >
          <path
            d="M114.958 0.638672H0.242188V27.586H114.958V0.638672Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_15932_142896)">
          <path
            d="M26.8165 0.66846C27.0225 0.66846 27.1991 0.638977 27.3757 0.638977C28.7589 0.638977 30.1715 0.638977 31.5547 0.638977C31.9078 0.609494 32.2315 0.786391 32.3787 1.08122C34.8802 4.97298 37.3817 8.83521 39.8832 12.6975C40.0009 12.8744 40.1481 13.0513 40.2658 13.2577L40.4129 13.1987V12.5796C40.4129 8.80574 40.4129 5.00246 40.4129 1.22863C40.4129 0.727425 40.5601 0.609494 41.031 0.638977C42.5613 0.66846 44.0916 0.638977 45.6807 0.638977V21.8667C45.5042 21.8667 45.3277 21.8961 45.1217 21.8961C43.7386 21.8961 42.326 21.8961 40.9427 21.8961C40.5895 21.9256 40.2658 21.7487 40.1187 21.4539C37.6171 17.5622 35.0862 13.6704 32.5553 9.77867C32.467 9.63126 32.3493 9.48385 32.2315 9.33644L32.0844 9.39538V21.8961H26.7871L26.8165 0.66846Z"
            fill="#003851"
          />
          <path
            d="M89.9727 6.35817C89.3548 8.06819 88.766 9.71922 88.1776 11.3703C86.9709 14.7018 85.7349 18.0629 84.5282 21.4239C84.4694 21.7482 84.1458 21.9546 83.8221 21.8956C82.6155 21.8662 81.4088 21.8662 80.1728 21.8956C79.8197 21.9546 79.4667 21.7188 79.4078 21.365C78.5542 18.8589 77.6712 16.3529 76.7886 13.8468C76.7297 13.6404 76.6411 13.4636 76.5234 13.1097C76.3763 13.493 76.288 13.6994 76.2292 13.9353C75.376 16.4119 74.493 18.8884 73.6688 21.365C73.6099 21.7188 73.2863 21.9546 72.9627 21.8956C71.7266 21.8662 70.4611 21.8662 69.225 21.8956C68.9603 21.9546 68.6955 21.7777 68.6068 21.5124C66.8117 16.5593 65.0167 11.6061 63.1918 6.68247C63.1624 6.59404 63.1624 6.50558 63.1035 6.35817C63.3099 6.35817 63.457 6.3287 63.6335 6.3287C64.9873 6.3287 66.3116 6.35817 67.6359 6.3287C67.989 6.26971 68.2832 6.50558 68.342 6.82988C69.1662 9.51282 69.9904 12.1958 70.8142 14.8492C70.873 15.0851 70.9613 15.321 71.0789 15.6748C71.1672 15.4684 71.226 15.3505 71.2555 15.2325C72.1679 12.4022 73.0804 9.60129 73.963 6.77093C74.0222 6.44663 74.3164 6.24023 74.6401 6.26971H74.6695C75.8761 6.29922 77.0828 6.29922 78.3189 6.26971C78.7602 6.26971 78.9073 6.41712 79.0249 6.8004C79.908 9.57181 80.791 12.3137 81.6736 15.0556C81.7324 15.2031 81.7913 15.3799 81.909 15.6748C82.3507 14.2301 82.7626 12.9623 83.1745 11.6651C83.7044 10.014 84.2046 8.36301 84.7342 6.68247C84.8228 6.41712 84.8817 6.24023 85.2347 6.24023C86.7062 6.24023 88.207 6.24023 89.6784 6.24023C89.7961 6.3287 89.8844 6.3287 89.9727 6.35817Z"
            fill="#003851"
          />
          <path
            d="M63.456 21.8663H58.3058V20.5985C58.2175 20.5691 58.1587 20.5691 58.1587 20.5691C55.5394 23.1931 50.5069 22.5739 48.0641 19.3013C45.7391 16.2056 45.9749 11.0166 48.6235 8.24522C50.9188 5.8571 54.7741 5.29693 57.3639 7.03642C57.6581 7.24278 57.9229 7.47865 58.2763 7.744V6.35832H63.4854L63.456 21.8663ZM51.5664 14.0828C51.5664 16.1171 53.0084 17.5913 54.98 17.5913C56.952 17.5913 58.394 16.1466 58.394 14.0828C58.394 12.019 56.9814 10.5744 54.98 10.5744C52.979 10.5744 51.5664 12.078 51.5664 14.0828Z"
            fill="#003851"
          />
          <path
            d="M97.3587 15.823C98.0064 14.1425 98.5654 12.6683 99.1538 11.1647C99.7426 9.66108 100.272 8.18694 100.89 6.71279C100.979 6.50643 101.155 6.3885 101.361 6.32951C102.891 6.30003 104.422 6.32951 105.981 6.32951C106.07 6.32951 106.158 6.35898 106.247 6.3885C106.188 6.59485 106.129 6.77174 106.07 6.94866C103.274 13.6413 100.449 20.3634 97.6529 27.056C97.5646 27.4393 97.1822 27.6751 96.8291 27.6162C95.3577 27.5867 93.9157 27.6162 92.3556 27.6162C92.5619 27.1149 92.7384 26.7022 92.915 26.2599C93.5034 24.9037 94.1216 23.577 94.6512 22.2208C94.7689 21.926 94.7689 21.6017 94.6512 21.3068C92.6502 16.5011 90.6488 11.6659 88.6478 6.88967C88.5889 6.74226 88.5301 6.59485 88.4414 6.35898C88.6772 6.35898 88.8537 6.32951 89.0302 6.32951C90.384 6.32951 91.7377 6.35898 93.0915 6.32951C93.474 6.27056 93.827 6.53591 93.9157 6.88967C94.9454 9.63161 96.0344 12.403 97.0939 15.1449C97.1528 15.2923 97.2116 15.4692 97.3587 15.823Z"
            fill="#003851"
          />
          <path
            d="M110.338 5.97535H109.455V5.62158H111.691V5.97535H110.809V7.89177H110.308V5.97535H110.338Z"
            fill="#003851"
          />
          <path
            d="M111.928 5.5918H112.634L113.458 7.36077L114.253 5.5918H114.959V7.86199H114.488L114.518 5.97508L113.664 7.86199H113.252L112.399 5.97508L112.428 7.86199H111.957V5.5918H111.928Z"
            fill="#003851"
          />
          <path
            d="M13.1912 8.92352V0.845215H0.242188C0.242188 0.933664 0.242188 0.99263 0.242188 1.0516C0.242188 3.91144 1.18393 6.68284 2.9497 8.92352H13.1912Z"
            fill="#7DCBC1"
          />
          <path
            d="M13.25 8.92334V19.0065C15.5161 20.8639 18.3707 21.8958 21.3137 21.8958H21.4902V8.92334H13.25Z"
            fill="#FF5E00"
          />
          <path
            d="M9.24723 13.2573C6.77512 12.4908 4.56793 10.9577 2.97873 8.92334H0.330078C0.330078 8.98229 0.330078 9.04128 0.330078 9.10022C0.330078 16.1466 6.03941 21.8958 13.073 21.8958H13.2496V19.0065C11.3956 17.5028 10.0124 15.5275 9.24723 13.2573Z"
            fill="#015C9A"
          />
          <path
            d="M9.24713 13.2573C8.77624 11.9306 8.54083 10.5154 8.54083 9.10022C8.54083 9.04128 8.54083 8.98229 8.54083 8.92334H2.94922C4.56783 10.9871 6.74561 12.4908 9.24713 13.2573Z"
            fill="#00BDCF"
          />
          <path
            d="M17.988 6.83025C19.6361 6.83025 20.9604 5.50352 20.9604 3.85247V0.845215H17.988C16.34 0.845215 15.0156 2.17195 15.0156 3.82299C15.0156 5.47404 16.34 6.83025 17.988 6.83025Z"
            fill="#7DCBC1"
          />
          <path
            d="M13.1909 8.92334H8.54102C8.54102 8.98229 8.54102 9.04128 8.54102 9.10022C8.54102 12.933 10.2774 16.5889 13.2497 19.0065V8.92334H13.1909Z"
            fill="#FF3A00"
          />
        </g>
      </svg>
    </>
  );
};

export default NawyDomainLogo;
